import { render, staticRenderFns } from "./mobileHome.vue?vue&type=template&id=e21452e2&scoped=true&"
import script from "./mobileHome.vue?vue&type=script&lang=js&"
export * from "./mobileHome.vue?vue&type=script&lang=js&"
import style0 from "./mobileHome.vue?vue&type=style&index=0&id=e21452e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21452e2",
  null
  
)

export default component.exports